import React from 'react';
import styled from 'styled-components';
import { ForecastCardIcon } from '../../common/forecastCardIcon';
import { IForecastCard } from '../../common/types';
import { HourCardCondition } from './hourCardCondition';
import { HourCardInfo } from './hourCardInfo';

type HourCardWeatherInfoProps = Pick<IForecastCard, 'description'| 'precipitation' | 'temperature' | 'hour' | 'iconCode'>;

export const HourCardWeatherInfo = ({ iconCode, hour, temperature, precipitation, description }: HourCardWeatherInfoProps) => {
    return (
        <Container>
            <ForecastCardIcon iconCode={iconCode} />
            <HourCardInfo hour={hour} description={description} />
            <HourCardCondition temperature={temperature} precipitation={precipitation} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    padding: 5px 10px;
    background-color: #f9f9f9;
    border-radius: 2px;
    height: 60px;
    width: 100%;
`;